import { TrackedObject } from 'tracked-built-ins';
import { getOwner } from '@ember/application';
import { tracked } from '@glimmer/tracking';
import AwayMessageEditPage from '../components/messaging-routes/away-message-edit.gjs';
import BaseHandler from '../components/messaging-routes/base-handler.js';
import ContactsHandler from '../components/messaging-routes/contacts-handler.js';
import ContactsPage from '../components/messaging-routes/contacts.gjs';
import ConversationHandler from '../components/messaging-routes/conversation-handler.js';
import ConversationListPage from '../components/messaging-routes/conversation-list.gjs';
import ConversationPage from '../components/messaging-routes/conversation.gjs';
import Service from '@ember/service';

export const ROUTE_MAP = {
  awayMessageEdit: {
    name: 'awayMessageEdit',
    component: AwayMessageEditPage,
    handler: BaseHandler,
  },
  contacts: {
    name: 'contacts',
    component: ContactsPage,
    handler: ContactsHandler,
  },
  conversation: {
    name: 'conversation',
    component: ConversationPage,
    handler: ConversationHandler,
  },
  conversationList: {
    name: 'conversationList',
    component: ConversationListPage,
    handler: BaseHandler,
  },
};

export default class MessagingNavigationService extends Service {
  @tracked currentRoute;

  constructor() {
    super(...arguments);
    this.#navigateTo(ROUTE_MAP.conversationList);
  }

  isCurrentRoute(routes) {
    if (Array.isArray(routes)) {
      return routes.some(route => route.name === this.currentRoute.name);
    }

    return routes.name === this.currentRoute.name;
  }

  async toConversationList() {
    await this.#navigateTo(ROUTE_MAP.conversationList);
  }

  async toConversation(conversation) {
    await this.#navigateTo(ROUTE_MAP.conversation, { conversation });
  }

  async toContacts() {
    await this.#navigateTo(ROUTE_MAP.contacts);
  }

  async toAwayMessageSettings() {
    await this.#navigateTo(ROUTE_MAP.awayMessageEdit);
  }

  async #navigateTo(route, options = {}) {
    if (this.currentRoute) {
      await this.currentRoute.handler.onLeave.perform();
    }

    this.currentRoute = this.#buildCurrentRoute(route, options);
    await this.currentRoute.handler.onVisit.perform();
  }

  #buildCurrentRoute(route, options) {
    return new TrackedObject({
      component: route.component,
      // eslint-disable-next-line new-cap
      handler: new route.handler(getOwner(this), options),
      name: route.name,
    });
  }
}
